import React, { useState, Component } from "react";

import { NavLink } from "react-router-dom";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Select from "react-select";

import logo from "../../public/assets/images/logo.png";
import profileimge from "../../public/assets/images/users/1.png";
// import logo from '../public/assets/images/logo.png';

const adminCheckes = [
  { value: "", label: "Select School Role" },
  { value: "yes", label: "YES" },
  { value: "no", label: "No" },
];

const Subjects = [
  { value: "", label: "Please Select" },
  { value: "1", label: "Biology" },
  { value: "2", label: "Math" },
  { value: "3", label: "Chemistry" },
];

const SelectSchool = [
  { value: "", label: "Please Select" },
  {
    value: "SNHU (Southern New Hampshire University)",
    label: "SNHU (Southern New Hampshire University)",
  },
  {
    value: "WCU (West coast University)",
    label: "WCU (West coast University)",
  },
];
const SchoolType = [
  { value: "", label: "Please Select" },
  { value: "1", label: "School Type 1" },
  { value: "2", label: "School Type 2" },
  { value: "3", label: "School Type 3" },
  { value: "4", label: "School Type 4" },
];

const Countrys = [
  { value: "", label: "Please Select" },
  { value: "United States", label: "United States" },
  { value: "Afghanistan", label: "Afghanistan" },
  { value: "Aland Islands", label: "Aland Islands" },
  { value: "Albania", label: "Albania" },
  { value: "American Samoa", label: "American Samoa" },
  { value: "Andorra", label: "Andorra" },
];

let TutorProfileSignup = () => {
  const [startDate, setStartDate] = useState(new Date());

  return (
    <>
      <div className="account-wrap student-profile">
        <div className="logo">
          <a href="/">
            <img src={logo} alt="" />
          </a>
        </div>
        <div className="container position-relative">
          <div className="row">
            <div className="col-md-7 offset-md-5">
              <div className="account-form-wrap form-signup">
                <div className="account-title">
                  <h3>Create Tutor Profile</h3>
                  <p>School / University Details </p>
                </div>
                <div className="form-floating no-icon">
                  <div className="form-row">
                    <div className="form-group col-sm-6">
                      <label>School/ College /University*</label>
                      <Select
                        className="form-control choosen-select"
                        options={SelectSchool}
                      />
                    </div>
                    <div className="form-group col-sm-6">
                      <label>School Name*</label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group col-sm-6">
                      <label>School Type*</label>
                      <Select
                        className="form-control choosen-select"
                        options={SchoolType}
                      />
                    </div>
                    <div className="form-group col-sm-6">
                      <label>Subject*</label>
                      <Select
                        className="form-control choosen-select"
                        options={Subjects}
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group col-sm-6">
                      <label>Country*</label>
                      <Select
                        className="form-control choosen-select"
                        options={Countrys}
                      />
                    </div>
                    <div className="form-group col-sm-6">
                      <label>State/Province*</label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group col-sm-6">
                      <label>City*</label>
                      <input type="text" className="form-control" />
                    </div>
                    <div className="form-group col-sm-6">
                      <label>Street Address*</label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group col-sm-6">
                      <label>Zip Code*</label>
                      <input type="text" className="form-control" />
                    </div>
                    <div className="form-group col-sm-6">
                      <label>Do you want to become admin*</label>
                      <Select
                        className="form-control choosen-select"
                        options={adminCheckes}
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="customCheck1"
                      />
                      <label
                        className="custom-control-label"
                        for="customCheck1"
                      >
                        I have read and accepted with the{" "}
                        <a href="https://schoolroomhelp.net/privacy-policy/" target="_blank">Privacy Policy</a>
                      </label>
                    </div>
                  </div>
                  <div className="form-row">
                    <button className="btn btn-round btn-secondary">
                      Register Now!
                    </button>
                  </div>
                  <div className="form-row f-size">
                    <em>
                      Already have an account?
                      <NavLink exact to="/tutor">
                        Login
                      </NavLink>
                    </em>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default TutorProfileSignup;
